import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation} from "react-router";
import api from './Services';
import AuthProvider from "./AuthProvider";
import PrivateRoute from "./PrivateRoute";
import Login from "./Login";
import './App.css'
import Navbar from './Navbar'
import Timesheet from './Timesheet'
import Projects from './Projects'

export default function App() {

//API DATA
  const [clients, setClients] = useState([]);
  const [projects, setProjects] = useState([]);
  const [clientsProjects, setClientsProjects] = useState([]);




/* ==============
  FETCH PROJECTS
  =============*/

    useEffect(() => {
      fetchProjects()
   }, []);
    const fetchProjects = async () => {
      api
          .get(`/wp-json/projectman/v1/projects?orderby=client&order=desc`)
          .then((response) => {
            setProjects(response.data)
          })
          .catch((err) => {
              console.log(err.message);
          });
    }



/* ==============
  FETCH CLIENTS
  =============*/

    useEffect(() => {
      fetchClients()
   }, []);
    const fetchClients = async () => {
      api
          .get(`/wp-json/wp/v2/client?_fields=id,title`)
          .then((response) => {
            setClients(response.data)
          })
          .catch((err) => {
              console.log(err.message);
          });
    }





/* ==============
  FETCH CLIENTS_PROJECTS
  =============*/

  useEffect(() => {
    fetchClientsProjects()
  }, []);
  const fetchClientsProjects = async () => {
      api
          .get(`/wp-json/projectman/v1/clients_projects`)
          .then((response) => {
            setClientsProjects(response.data)
          })
          .catch((err) => {
              console.log(err.message);
          });
  }










  return (
    <>

    <div className="min-h-screen bg-stone-100 p-4">
      <div className="max-w-7xl mx-auto">
      <Navbar />      
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<PrivateRoute />}>
            <Route path="/" element={<Timesheet projects={projects} clients={clients} clientsProjects={clientsProjects} fetchProjects={fetchProjects} fetchClientsProjects={fetchClientsProjects}/>} />
            <Route path="/projects" element={<Projects projects={projects} clients={clients} clientsProjects={clientsProjects} fetchProjects={fetchProjects} fetchClientsProjects={fetchClientsProjects}/>} />
          </Route>  
        </Routes>  
      </AuthProvider>
      </div>
    </div>

    </>
  );
}
